(function ($) {
    $.fn.uploadToAzureTemporaryBlob = function (temporaryUploadType, rotationOrPortfolioItemId) {
        return this.each(function () {

            var $documentSelectorFileInputContainer = $(this);

            var temporaryUploadUrl;
            if (temporaryUploadType === 'EvidenceSection') {
                temporaryUploadUrl = '/portfolio-item/document-temporary-upload/for-evidence-section/' + rotationOrPortfolioItemId;
            } else if (temporaryUploadType === 'MandatoryCertificate') {
                temporaryUploadUrl = '/portfolio-item/document-temporary-upload/for-mandatory-certificate/' + rotationOrPortfolioItemId;
            }

            var runUploadFile = function(file) {
                var formData = new FormData();
                formData.append('file', file);

                $.ajax({
                    url: temporaryUploadUrl,
                    type: 'POST',
                    data: formData,
                    processData: false, // required for file uploads with jQuery
                    contentType: false, // sets the correct Content-Type header
                    success: function(response) {
                        if (response.success) {
                            $documentSelectorFileInputContainer.trigger('portfolioItemDocument:uploadSucceeded', {
                                uniquePathToTemporaryBlob: response.uniquePathToTemporaryBlob
                            });
                        } else {
                            $documentSelectorFileInputContainer.trigger('portfolioItemDocument:uploadFailed', {
                                errors: [prepareErrorMessage('invalidStatusCode')]
                            });
                        }
                    },
                    error: function() {
                        $documentSelectorFileInputContainer.trigger('portfolioItemDocument:uploadFailed', {
                            errors: [prepareErrorMessage('uploadFailed')]
                        });
                    }
                });
            };

            var validate = function (file) {
                var errors = [];

                var validateFileSize = function (fileName, fileSize) {
                    var isPdf = fileName.match(/^.+\.pdf$/);
                    var sizeLimitMB = isPdf ? 4 : 1;
                    var bytesInOneMegabyte = 1048576;
                    return fileSize <= sizeLimitMB * bytesInOneMegabyte;
                };

                if (validateFileSize(file.name, file.size) === false) {
                    errors.push('The chosen files size exceeds the maximum limit, please see the upload tips section below.');
                }

                var validateFileNameLength = function (fileName) {
                    return fileName.length <= 75;
                };

                if (validateFileNameLength(file.name) === false) {
                    errors.push('The chosen files name is too long, please see the upload tips section below.');
                }

                var validateFileNameExtension = function (fileName) {
                    // allow one or more non dot characters, but must end with dot followed by any of listed extensions
                    var fileNameRegEx = /^[^.]+\.(jpg|jpeg|gif|png|rtf|doc|docx|ppt|pptx|pdf)$/;
                    return fileName.toLowerCase().match(fileNameRegEx) !== null;
                };

                if (validateFileNameExtension(file.name) === false) {
                    errors.push('The chosen files type is not on the list of accepted types, please see the upload tips section below.');
                }

                var validateFileNameCharacters = function (fileName) {
                    // check all characters before first dot, are alphanumeric, all characters after first dot, are not dots.
                    var fileNameRegEx = /^[0-9a-zA-Z-_ ]+\.[^.]+$/;
                    return fileName.match(fileNameRegEx) !== null;
                };

                if (validateFileNameCharacters(file.name) === false) {
                    errors.push('The chosen files name must only contain letters, numbers, spaces, dashes and underscores. Please see the upload tips section below.');
                }

                return errors;
            };

            // expects to be called on a div containing file inputs (this is so the file input can be cloned and is easily replaceable)
            $documentSelectorFileInputContainer.on('change', 'input[type=file]', function () {
                var $fileInput = $(this);
                // extra check that file has been selected to avoid IE bug where change event is called twice
                if ($fileInput.val()) {
                    var file = $fileInput[0].files[0];

                    var errors = validate(file);
                    if (errors.length > 0) {
                        $documentSelectorFileInputContainer.trigger('portfolioItemDocument:uploadFailed', {errors: errors});
                        return;
                    }

                    $documentSelectorFileInputContainer.trigger('portfolioItemDocument:uploadInProgress');

                    runUploadFile(file);
                }
            });

            var prepareErrorMessage = function (errorCode) {
                var errorTemplate = 'There was a problem uploading your file, please try again ' +
                    '(if this issue persists please contact support quoting error code "<% errorCode %>")';
                return Mustache.render(errorTemplate, {errorCode: errorCode});
            };

        });
    };
}(jQuery));